module.exports = __webpack_public_path__ + "static/media/prod-1.4f70dabc.svg";